export default "__VITE_ASSET__W0lQCKMm__"